<template>
  <div>
    <v-dialog persistent v-model="modalOk" :active="modalOk" :on-cancel="() => {
      modalOk = false
    }
      " max-width="1100">
      <form @submit.prevent="Save">
        <v-card flat>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Enquiry Code: {{ this.selectedEnquiryCode }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn icon dark @click="modalOk = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-card-title class="font-weight-medium">
              Enquiry Assigned To:
              {{
                this.currentAssignedUser
                ? `${this.currentAssignedUser.firstName} ${this.currentAssignedUser.lastName}`
                : '-'
              }}
            </v-card-title>
            <v-data-table :headers="assignToHeader" hide-default-footer disable-pagination :items="selectedEnquiry">
              <template v-slot:item.previousAssignee="{ item }">
                <span>{{
                  item.previousAssignee
                  ? item.previousAssignee.firstName +
                  ' ' +
                  item.previousAssignee.lastName
                  : '-'
                }}</span>
              </template>
              <template v-slot:item.CurrentAssignee="{ item }">
                <span>{{
                  item.CurrentAssignee
                  ? item.CurrentAssignee.firstName +
                  ' ' +
                  item.CurrentAssignee.lastName
                  : '-'
                }}</span>
              </template>
              <template v-slot:item.spancoStage="{ item }">
                <span>{{ item.spancoName || '-' }}</span>
              </template>

              <template v-slot:item.date="{ item }">
                <span>{{ new Date(item.updatedAt).toLocaleString() }}</span>
              </template>

              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="assignToMe" color="accent">assign to me</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
    <v-container fluid>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog v-model="sendLinkDialog" max-width="600">
            <template v-slot:default="sendLinkDialog">
              <v-card>
                <v-toolbar dark color="primary">
                  <v-toolbar-title> Online Admission</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon dark @click="sendLinkDialog.value = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-chip class="ma-1" color="gray">
                        Opted Class :
                        <v-chip class="ma-2" color="gray">
                          {{ selectedclassName }}
                        </v-chip></v-chip>
                    </v-col>
                    <v-col>
                      <span class="body-2 font-weight-medium">
                        Select Section <span class="error--text">*</span>
                      </span>
                      <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="sectionID" required
                        item-text="name" item-value="id" :items="sections" key="id">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="primary" :disabled="hasClicked" @click.prevent="confirmSendTutionFee()">
                    Send Tution Fee Payment Link To Parent
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog v-model="sendLinkDialogOffline" max-width="650">
            <template v-slot:default="sendLinkDialogOffline">
              <v-card>
                <v-toolbar dark color="purple">
                  <v-toolbar-title> Offline Admission</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-btn icon dark @click="sendLinkDialogOffline.value = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-chip class="ma-1" color="gray">
                        Opted Class :
                        <v-chip class="ma-2" color="gray">
                          {{ selectedclassName }}
                        </v-chip></v-chip> </v-col><v-col>
                      <span class="body-2 font-weight-medium">
                        Select Section <span class="error--text">*</span>
                      </span>
                      <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="sectionID" required
                        item-text="name" item-value="id" :items="sections" key="id">
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="purple" :disabled="hasClicked" @click.prevent="sendAdmissionLink(true)">
                    Pay Tution Fee Offline
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="headline font-weight-bold">Follow Up Details</v-subheader>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="4">
          <material-card class="v-card-profile" :class="{ 'mt-13': $vuetify.breakpoint.smAndDown }"
            avatar="/data-sources/avatars/default-user.png">
            <v-card-text class="text-center">
              <v-btn class="mb-6 white--text" elevation="1" color="green" rounded>
                {{
                  enquiryDetails.spancoStatus && enquiryDetails.enquiryStage.name == admissionConfirmedObj && (isAdmissionConfirmed == "inProcess" || isAdmissionConfirmed == "pending")
                  ? 'Close'
                  : this.enquiryDetails.spancoStatus
                  ? this.enquiryDetails.spancoStatus
                  : spancoDefaultStatus
                }}
              </v-btn>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">
                      Student Name
                    </td>
                    <td>
                      {{ this.enquiryDetails.studentFirstName }}
                    </td>
                  </tr>
                  <tr v-if="this.enquiryDetails.fatherName">
                    <td class="font-weight-bold body-2 subtitle">
                      Parent Name
                    </td>
                    <td>
                      {{ this.enquiryDetails.fatherName }}
                    </td>
                  </tr>
                  <tr v-if="this.enquiryDetails.motherName">
                    <td class="font-weight-bold body-2 subtitle">
                      Mother Name
                    </td>
                    <td>
                      {{ this.enquiryDetails.motherName }}
                    </td>
                  </tr>
                  <tr v-if="this.enquiryDetails.studentClass">
                    <td class="font-weight-bold body-2 subtitle">Class</td>
                    <td>
                      {{
                        this.enquiryDetails.studentClass
                        ? this.enquiryDetails.studentClass.name
                        : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">
                      Enquiry Code
                    </td>
                    <td>
                      {{ this.enquiryDetails.enquiryCode }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">
                      Branch Name
                    </td>
                    <td>
                      {{
                        this.enquiryDetails.franchisee
                        ? this.enquiryDetails.franchisee.companyName
                        : ''
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">
                      Academic Year
                    </td>
                    <td>
                      {{
                        this.enquiryDetails.franchiseeAcademicYear
                        ? this.enquiryDetails.franchiseeAcademicYear
                          .academicYear
                        : ''
                      }}
                    </td>
                  </tr>
                  <tr v-if="this.enquiryDetails.fatherMobile">
                    <td class="font-weight-bold body-2 subtitle">
                      Parent Mobile
                    </td>
                    <td>
                      <v-btn @click="connectCall('father')" elevation="1" dark color="green" rounded><v-icon
                          left>mdi-phone</v-icon> CALL
                      </v-btn>
                    </td>
                  </tr>
                  <tr v-if="this.enquiryDetails.motherMobile">
                    <td class="font-weight-bold body-2 subtitle">
                      Mother Mobile
                    </td>
                    <td>
                      <v-btn @click="connectCall('mother')" elevation="1" dark color="green" rounded><v-icon
                          left>mdi-phone</v-icon> CALL
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">
                      Parent Email
                    </td>
                    <td>
                      {{
                        this.enquiryDetails.fatherEmailID
                        ? this.enquiryDetails.fatherEmailID
                        : '-'
                      }}
                    </td>
                  </tr>
                  <tr v-if="this.enquiryDetails.motherEmailID">
                    <td class="font-weight-bold body-2 subtitle">
                      Mother Email
                    </td>
                    <td>
                      {{
                        this.enquiryDetails.motherEmailID
                        ? this.enquiryDetails.motherEmailID
                        : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">
                      Center Name
                    </td>
                    <td>
                      {{
                        this.enquiryDetails.franchiseeName
                        ? this.enquiryDetails.franchiseeName
                        : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">Message</td>
                    <td>
                      {{
                        this.enquiryDetails.message
                        ? this.enquiryDetails.message
                        : '-'
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold body-2 subtitle">City</td>
                    <td>
                      {{
                        this.enquiryDetails.city
                        ? this.enquiryDetails.city
                        : '-'
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <v-card-actions v-if="!isBSKRoleUser">
                <v-spacer></v-spacer>
                <v-btn v-on:click="editRoute" :disabled="this.enquiryDetails.enrollmentCode !== null ? true : false
                    " color="success">
                  <v-icon left>mdi-pencil</v-icon>
                  Edit
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </material-card>
        </v-col>
        <v-col cols="12" sm="12" md="8">
          <material-card min-height="500" icon="mdi-clipboard-text" inline title="Details Form">
            <template v-if="showAdmissionFormFeeBtnLInk">
              <v-btn top left class="mt-10 mr-5" color="error" dark small v-on:click="confirmSendAdmissionLink()" v-if="enquiryDetails &&
                enquiryDetails.enquiryStage &&
                enquiryDetails.enquiryStage.level > 3
                ">
                Admission Form Fill - Send Link
              </v-btn>
              <v-btn top left class="mt-10" color="info" dark small
                v-on:click="sendApplicationLink(enquiryCode, true, false)" v-if="enquiryDetails &&
                  enquiryDetails.enquiryStage &&
                  enquiryDetails.enquiryStage.level > 3
                  ">
                Admission Form Fill - Offline
              </v-btn>
            </template>
            <v-card-component>
              <v-simple-table>
                <template>
                  <thead>
                    <tr>
                      <th id="enquiryCode" class="text-left">Enquiry code</th>
                      <th id="status" class="text-left">Status</th>
                      <th id="enquiryDate" class="text-left">Enquiry Date</th>
                      <th id="followUpDate" class="text-left">Follow-up Date</th>
                      <th id="interactionDate" class="text-left">Interaction Date</th>
                      <th id="enquiryAssignedTo" class="text-left">Enquiry assigned to</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ this.enquiryDetails.enquiryCode }}</td>
                      <td>
                        {{
                          enquiryDetails.enquiryStage && enquiryDetails.enquiryStage.name === admissionConfirmedObj && isAdmissionConfirmed === "inProcess" || isAdmissionConfirmed === "pending"
                          ? 'Temporarily Confirmed'
                          : enquiryDetails.enquiryStage?.name || spancoDefaultStage

                        }}
                      </td>
                      <td>{{ this.enquiryDetails.dateOfEnquiry }}</td>
                      <td>
                        {{
                          this.enquiryDetails.followupDate
                          ? this.enquiryDetails.followupDate
                          : '-'
                        }}
                      </td>
                      <td>
                        {{
                          this.enquiryDetails.interactionDate
                          ? this.enquiryDetails.interactionDate
                          : '-'
                        }}
                      </td>
                      <td>
                        {{
                          enquiryAssignedTo
                          ? `${enquiryAssignedTo.firstName}- ${enquiryAssignedTo.lastName || '-'
                          }`
                          : '-'
                        }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-component>
            <v-card-component v-if="this.enquiryDetails  &&
                this.enquiryDetails.enquiryStage &&
                (this.enquiryDetails.currentStatus ===
                  this.applicationFeeLinkObj ||
                  this.enquiryDetails.currentStatus ===
                  this.admissionFormCompletedObj)&& showAdmissionFormFeeBtnLInk
                ">
              <v-card-actions class="justify-center">
                <div v-if="isRazorPayAccount">
                  <v-tooltip bottom color="error">
                    <template v-slot:activator="{ on, attrs }">
                      <div style="border: solid 1px #000" v-bind="attrs" v-on="on">
                        <button class="v-btn v-btn--disabled v-btn--has-bg theme--light v-size--default" type="button"
                          @click="
                            confirmSendApplicationLink(enquiryCode, false, true)
                            ">
                          <v-icon left>mdi-email-send</v-icon> Application Fee
                          Payment - Send Link
                        </button>
                      </div>
                    </template>
                    <span>You have to open Razorpay account for online
                      payment.</span>
                  </v-tooltip>
                </div>
                <div v-else class="razorpaydisabled" style="border: solid 1px #000" @mouseover="toolTipFlag = true"
                  @mouseleave="toolTipFlag = false">
                  <v-btn v-if="!this.disableAppFeeLink" class="red white--text" :disabled="isRazorPayAccount"
                    style="pointer-events: auto !important; border-radius: 1px" @click="
                      confirmSendApplicationLink(enquiryCode, false, true)
                      ">
                    <v-icon left>mdi-email-send</v-icon> Application Fee Payment
                    - Send Link
                  </v-btn>
                </div>
                <div class="razorpaydisabled" style="border: solid 1px #000; margin: 3px">
                  <v-btn class="white--text" style="
                      pointer-events: auto !important;
                      color: #61cbe3;
                      padding-top: 8px;
                      padding-bottom: 8px;
                      height: 35px;
                      border-radius: 0px;
                    " top right color="info" dark small v-on:click="sendApplicationLink(enquiryCode, true, true)" v-if="!this.disableAppFeeLink &&
                      this.enquiryDetails.currentStatus !==
                      this.admissionFormCompletedObj &&
                      (this.enquiryDetails.currentStatus ===
                        this.applicationFeeLinkObj ||
                        this.enquiryDetails.currentStatus === this.dropOffObj)
                      ">
                    <v-icon left>mdi-arrow-right-bold</v-icon> Application Fee
                    Payment - Offline Pay
                  </v-btn>
                </div>
              </v-card-actions>
              <v-card-actions class="justify-center" v-if="enquiryDetails.currentStatus === admissionFormCompletedObj ||
                this.enquiryDetails.currentStatus ===
                this.applicationFeeLinkObj ||
                this.enquiryDetails.currentStatus === this.dropOffObj
                ">
                <div class="razorpaydisabled" style="border: solid 1px #000; margin: 3px">
                  <v-btn class="white--text" style="
                      pointer-events: auto !important;
                      color: #61cbe3;
                      border-radius: 1px;
                      padding-top: 8px;
                      padding-bottom: 8px;
                      height: 35px;
                    " top right color="success" small dark @click="assignEnquiryID(enquiryDetails)"
                    v-if="this.enquiryDetails.enquiryStage.level > 3">
                    Fee Plan Assign
                  </v-btn>
                </div>
                <!-- tuition fee -->
                <div v-if="isRazorPayAccount">
                  <v-tooltip bottom color="error">
                    <template v-slot:activator="{ on, attrs }">
                      <div style="border: solid 1px #000; margin-left: 3px" v-bind="attrs" v-on="on">
                        <button class="v-btn v-btn--disabled v-btn--has-bg theme--light v-size--default" type="button" top
                          right color="error" dark small @click="
                            toggleSectionModal(
                              enquiryDetails.id,
                              enquiryDetails.classID,
                              enquiryDetails.enquiryCode
                            )
                            ">
                          Tuition Fee Payment - Send Link
                        </button>
                      </div>
                    </template>
                    <span>You have to open Razorpay account for online
                      payment.</span>
                  </v-tooltip>
                </div>
                <div v-else class="razorpaydisabled" style="border: solid 1px #000; margin: 3px">
                  <v-btn class="white--text" :disabled="isRazorPayAccount" style="
                      pointer-events: auto !important;
                      color: #61cbe3;
                      border-radius: 1px;
                      height: 35px;
                    " top right color="error" dark small @click="
                      toggleSectionModal(
                        enquiryDetails.id,
                        enquiryDetails.classID,
                        enquiryDetails.enquiryCode
                      )
                      ">
                    Tuition Fee Payment - Send Link
                  </v-btn>
                </div>
                <div class="razorpaydisabled" style="border: solid 1px #000; margin: 3px">
                  <v-btn class="white--text" style="
                      pointer-events: auto !important;
                      color: #61cbe3;
                      border-radius: 1px;
                      height: 35px;
                    " top right color="info" dark small @click.prevent="
                      toggleSectionModalOffline(
                        enquiryDetails.id,
                        enquiryDetails.classID,
                        enquiryDetails.enquiryCode
                      )
                      ">
                    Tuition Fee Payment - Offline Pay
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card-component>
            <div v-if="(isBSKRoleUser && enquiryDetails.enquiryStage && enquiryDetails.enquiryStage.level < 3) || !isBSKRoleUser">
              <p v-if="enquiryDetails.enquiryStage.name === 'Tuition Fee Paid'">
                  Note: To confirm admission, the Facilitation Fee and Curriculum kits amounts must be paid in full,
                  and the admission form must be completed. Only then can the 'Admission Confirmed'
                  status be saved and a Student EnrollmentID generated.
                </p>

              <v-card-component title="Enter Follow up Details" icon="mdi-calendar-multiselect" v-if="(this.enquiryDetails.currentStatus !==
                admissionFormCompletedObj &&
                this.enquiryDetails.currentStatus !== temporarilyConfirmed &&
                enquiryDetails.currentStatus !== admissionConfirmedObj) ||
                (this.enquiryDetails.currentStatus === dropOffObj &&
                  this.enquiryDetails.enquiryStage.level == 4) ||
                this.enquiryDetails.currentStatus === this.applicationFeeLinkObj ||
                (
                  enquiryDetails.currentStatus === temporarilyConfirmed &&
                  !validClassIDs.some(id => id === enquiryDetails?.classID)
                )                ">
                <form autocomplete="off" @submit.prevent="onSubmit">
                  <v-row>
                    <v-col cols="12" sm="4">
                      <span class="body-2 font-weight-medium">Status</span>
                      <v-autocomplete class="my-0 py-1" placeholder="Select status" v-model="enquiryStage" key="id" required
                        @change="getEnquiryStages()" single-line :items="sortedEnquiryStageData"
                        :item-text="sortedEnquiryStageData ? 'name' : ''" item-value="id">
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <span class="body-2 font-weight-medium">Next followup date time</span>
                      <v-datetime-picker v-model="followupDateTime" :minToDate="minToDate" />
                    </v-col>
                    <v-col cols="12" sm="4">
                      <span class="body-2 font-weight-medium">Response</span>
                      <v-autocomplete class="my-0 py-1" placeholder="Select status" v-model="enquiryResponse"
                        :required="isResponseRequired" key="id" single-line :items="enquirySubRemarksData"
                        :item-text="enquirySubRemarksData ? 'name' : ''" item-value="id" @input="passed()"
                        :item-disabled="isDisabled"
                        >
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div v-for="(status, index) of this.enquiryStageData" :key="index" style="padding-left: 1%;">
                        <div v-if="status.statusName === 'On Board' && studentCategory === 'Parent Toddler'">
                          <span class="body-2 font-weight-medium">Class Start Date</span>
                          <custom-date-picker @input="changeClassEndDate()" v-model="classStartDate" />

                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <div v-for="(status, index) of this.enquiryStageData" :key="index" style="padding-left: 1%;">
                        <div v-if="status.statusName === 'On Board' && studentCategory === 'Parent Toddler'">
                          <span class="body-2 font-weight-medium">Class End Date</span>
                          <v-text-field class="ml-5 mb-1" v-model="classEndDate" disabled></v-text-field>
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <span class="body-2 font-weight-medium">Remarks</span>
                      <v-textarea rows="3" maxlength="500" placeholder="Write Remarks" clearable v-model="actionRemarks"
                        clear-icon="mdi-close-circle" counter="500" single-line></v-textarea>
                    </v-col>
                    <v-col cols="12">
                      <v-card-actions class="d-flex justify-end">
                        <v-btn
                          bottom
                          right
                          outlined color="darkblue"
                          :to="{
                            name: 'assignServicePlan',
                            params: { enquiryID: this.enquiryDetails.id, franchiseeID: this.enquiryDetails.franchiseeID, academicYearID: this.enquiryDetails.academicYearID, isTransport: false }
                          }"
                          v-if="showAssignBtn"
                        >
                          Assign Service
                        </v-btn>
                        <v-btn bottom right elevation="1" color="primary" type="submit">
                          <v-icon left> mdi-content-save </v-icon>
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                  <v-row justify="space-around">
                    <v-col cols="12" md="12" lg="12" xs="12" sm="12">
                      <v-dialog v-model="dialogModel" width="50%" persistent>
                        <v-card style="overflow:hidden;">
                          <v-toolbar dark elevation="0" class="primary">
                            <v-toolbar-title> {{ modelTitle }} </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <v-btn icon dark @click.prevent="closeModal()">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </v-toolbar-items>
                          </v-toolbar>
                          <v-form validate-on="submit" @submit.prevent="addActionStageData">
                            <v-card-text v-for="question of subResponseQuestion" :key="question.name">
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <span class="body-2 font-weight-medium">
                                    {{ question.name }}
                                    <span class="error--text">*</span>
                                  </span>
                                  <v-text-field v-model="question.value" required :type="question.type"
                                    :max="question.maxlength"></v-text-field>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-form>
                          <v-row>
                            <v-col cols="12" sm="4">
                              <v-btn elevation="1" color="primary" type="submit" absolute bottom right>
                                Add
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </form>
              </v-card-component>
              <div v-else-if="addNewFollowupData.msg === 'Error in Kit Order!' || isAdmissionConfirmed === 'pending' ">
                <template>
                  <div class="d-flex justify-end">
                    <v-btn
                        color="blue"
                        class="font-weight-bold text--white"
                        @click="reAssignOrder"
                      >
                        Re-Assign Order
                    </v-btn>
                  </div>
                  </template>
              </div>
              <div v-else>
                  <v-subheader class="title d-flex justify-center">
                  <span class="spanTitle">
                    {{
                      this.enquiryDetails.currentStatus ===
                      admissionFormCompletedObj
                      ? `Please Assign Fee plan and send admission Fee link , Else check whether Offline payment approval is
                    done`
                      : enquiryDetails.currentStatus === applicationFeeLinkObj
                        ? 'Click on "Send Application Link To Parent" button to Pay Application Fees'
                        : enquiryDetails.currentStatus === admissionConfirmedObj && this.isAdmissionConfirmed === 'confirmed'
                        ? 'Student On boarded'
                          : ''
                    }}

                    <template v-if="enquiryDetails.currentStatus === temporarilyConfirmed && validClassIDs.includes(enquiryDetails?.classID)">
                        <p style=" margin-top: 130px;">Dear Business Partner, </br>
                          Congratulations on completing the admission process. In order to On-board the student and to confirm the admission, please proceed with the payment of Facilitation Fee (Royalty), Curriculum Kit-1 and Curriculum Kit-2 by clicking
                          <a
                            href="/payments/transfer-franchiseeToBB"
                            target="_blank"
                            class="hyperlink"
                          >
                          here
                        </a>
                         Thank you.
                     </p>
                    </template>
                    {{
                      this.enquiryDetails.currentStatus === dropOffObj
                        ? 'This student is drop off at this stage'
                        : enquiryDetails.currentStatus !== admissionConfirmedObj || this.isAdmissionConfirmed !== 'inProcess'
                          ? 'Please check status and if something is wrong, Please contact admin'
                          : ''
                    }}
                  </span>

                </v-subheader>
              </div>
            </div>
          </material-card>
        </v-col>
        <v-col cols="12">
          <material-card title="History Followup Details" icon="mdi-mail">
            <v-data-table :footer-props="{
                        'items-per-page-options': [5, 10, 20, 40]
                      }" :items-per-page="10" :headers="headers" :items="followupData">
              <template v-slot:item.interactionDate="{ item }">
                <span>{{
                  item.interactionDate ? item.interactionDate : ''
                }}</span>
              </template>
              <template v-slot:item.previousStatus="{ item }">
                <span>{{
                  item.previousStage ? item.previousStage.name : ''
                }}</span>
              </template>
              <template v-slot:item.statusChangedTo="{ item }">
                <span>{{
                  item.currentStage && item.currentStage.name === admissionConfirmedObj && isAdmissionConfirmed === "inProcess"
                  ? 'Temporarily Confirmed'
                  : item.currentStage?.name || ''
                  }}
                </span>

              </template>
              <template v-slot:item.followUpBy="{ item }">
                <span>{{
                  item.followUpBy && item.user
                  ? `${item.user.firstName} ${item.user.lastName || ''}(${item.user.email
                  })`
                  : item.createdBy
                }}</span>
              </template>
              <template v-slot:item.response="{ item }">
                <span>{{
                  item.enquirySubRemark ? item.enquirySubRemark.name : ''
                }}</span>
              </template>
              <template v-slot:item.remarks="{ item }">
                <span>{{ item.actionRemarks ? item.actionRemarks : '' }}</span>
              </template>
              <template v-slot:item.nextFollowUp="{ item }">
                <span>{{ item.nextFollowUp ? item.nextFollowUp : '' }}</span>
              </template>
              <template v-slot:item.actionStageQuestions="{ item }">
                <div v-if="item.actionStageQuestions.length">
                  <table>
                    <caption></caption>
                    <div v-for="que of item.actionStageQuestions" :key="que.name">
                      <th>{{ que.name }} -</th>
                      <th>: {{ que.value }}</th>
                    </div>
                  </table>
                </div>
              </template>
              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
              </template>
            </v-data-table>
          </material-card>
        </v-col>
        <v-col cols="12">
          <material-card title="Call Logs Details" icon="mdi-mail">
            <v-data-table :footer-props="{
              'items-per-page-options': [5, 10, 20, 40]
            }" :items-per-page="10" :headers="callLogsheaders" :items="callLogsData">
              <template v-slot:item.firstCallAnswerAt="{ item }">
                <span>{{
                  item.firstCallAnswerAt ? item.firstCallAnswerAt : '-'
                }}</span>
              </template>
              <template v-slot:item.secondCallAnswerAt="{ item }">
                <span>{{
                  item.secondCallAnswerAt ? item.secondCallAnswerAt : '-'
                }}</span>
              </template>
              <template v-slot:item.callDisconnectAt="{ item }">
                <span>{{
                  item.callDisconnectAt ? item.callDisconnectAt : '-'
                }}</span>
              </template>
              <template v-slot:item.firstCallStatus="{ item }">
                <span>{{
                  item.firstCallStatus ? item.firstCallStatus : 'Failed'
                }}</span>
              </template>
              <template v-slot:item.secondCallStatus="{ item }">
                <span>{{
                  item.secondCallStatus ? item.secondCallStatus : 'Failed'
                }}</span>
              </template>
              <template v-slot:item.createdAt="{ item }">
                <span>{{ item.createdAt ? item.createdAt : '-' }}</span>
              </template>

              <template v-slot:no-data>
                <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
              </template>
            </v-data-table>
          </material-card>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="linkSendConfirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="primary justify-center white--text">
              Confirmation
            </v-card-title>
            <v-card-text>
              <v-card-subtitle class="text-center text-h6">
                Send Admission Form Fill Link to Email id:
              </v-card-subtitle>
              <v-radio-group v-model="isParent" row>
                <v-radio selected label="Parent/Guardian" :value="true"></v-radio>
                <v-radio label="Mother" :value="false"></v-radio>
              </v-radio-group>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="sendApplicationLink(enquiryCode, false, false)">
                Send
              </v-btn>
              <v-btn color="error darken-1" text @click="linkSendConfirmDialog = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-row justify="center">
        <v-dialog v-model="admissionLinkSendConfirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="primary justify-center white--text">
              Confirmation
            </v-card-title>
            <v-card-text>
              <v-card-subtitle class="text-center text-h6">
                Send Tution Fee Link to Email id:
              </v-card-subtitle>
              <v-radio-group v-model="isParent" row>
                <v-radio selected label="Parent/Guardian" :value="true"></v-radio>
                <v-radio label="Mother" :value="false"></v-radio>
              </v-radio-group>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="sendAdmissionLink()">
                Send
              </v-btn>
              <v-btn color="error darken-1" text @click="admissionLinkSendConfirmDialog = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-row justify="center">
        <v-dialog v-model="applicationLinkSendConfirmDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="primary justify-center white--text">
              Confirmation
            </v-card-title>
            <v-card-text>
              <v-card-subtitle class="text-center text-h6">
                Send Application Fee Link to Email id:
              </v-card-subtitle>
              <v-radio-group v-model="isParent" row>
                <v-radio selected label="Parent/Guardian" :value="true"></v-radio>
                <v-radio label="Mother" :value="false"></v-radio>
              </v-radio-group>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="sendApplicationLink(enquiryCode, false, true)">
                Send
              </v-btn>
              <v-btn color="error darken-1" text @click="applicationLinkSendConfirmDialog = false">
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <v-dialog v-model="showCenterChangeDialog" persistent max-width="500">
        <v-card>
          <v-toolbar elevation="0" dark color="accent">
            <v-toolbar-title> Change Center </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="8" lg="8" xs="12" sm="6">
                <label class="font-weight-medium body-2">
                  Franchisee
                  <span class="requir error--text">*</span>
                </label>
                <v-autocomplete
                  class="my-0 py-1"
                  required
                  placeholder="Select Franchisee"
                  clearable
                  v-model.trim="selectedFranchiseeID"
                  :items="franchiseeList"
                  key="id"
                  item-value="id"
                  item-text="companyName"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" sm="6" xs="12">
                <v-btn class="mt-5" @click="changeCenter" small color="accent" width="100%">Change Center</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <loading-icon :value="isLoading" />
    </v-container>
    <component :is="isCompo" @uniformsize="selectAllModal = true" @setIsCompop="setComponentFlag" :enquiryID="enquiryIDD"
      :STUDENT_DATA="STUDENT_DATA">
    </component>
  </div>
</template>
<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import _ from 'lodash'
import stores from '@/stores'
import AssignFeePlan from '../../Fees/FeeComponent/assignFeePlan'
import { mapGetters } from 'vuex'
import CustomDatePicker from '@/components/template/CustomDatePicker'

export default {
  components: {
    VCardComponent,
    MaterialCard,
    AssignFeePlan,
    CustomDatePicker
  },
  name: 'followupDetails',
  props: ['enquiryCode', 'radio2', 'spancoStatus1', 'admin', 'spancoStage1'],
  data () {
    return {

      loadingComponent: null,
      emailAddress: '',
      selectAllModal: false,
      dialog: false,
      dialogModel: false,
      userID: '',
      user: stores.user.me,
      fullName: '',
      planAssignModal: false,
      enquiryDetails: [
        {
          enquiryCode: '',
          enquiryDate: '',
          status: '',
          interactionDate: '',
          followupDate: ''
        }
      ],
      isAdmissionConfirmed: '',
      isAdmin: null,
      enquiryResponse_NI: '',
      isWrite: false,
      canEdit: false,
      enquiryIDD: null,
      spancostg: '',
      radio: 'all',
      modalOk: false,
      enquiryStageData: [],
      enquirySubRemarksData: [],
      enquirySubRemarksDataforModal: [],
      followupData: [],
      callLogsData: [],
      enquiryStage: '',
      enquirySubRemarks: '',
      enquiryResponse: '',
      isResponseRequired: false,
      followupDate: moment(new Date()).format('YYYY-MM-DD'),
      minToDate: moment().format('YYYY-MM-DD'),
      followupTime: '',
      actionRemarks: '',
      isLoading: false,
      refreshFlag: 0,
      enableModal: false,
      isFollowUps: 0,
      actionRemarks_NI: '',
      showNIEnqButton: 1,
      minDatetime: new Date(),
      notInterestedReasons: [],
      followupDateTime: new Date(),
      classStartDate: new Date().toISOString().slice(0, 10),
      enquiryType: '',
      applicationFeeLinkObj: '',
      dropOffObj: '',
      admissionFormCompletedObj: '',
      admissionConfirmedObj: '',
      onlineCounsellingDONE: '',
      offlineCounsellingDONE: '',
      enquiryAssignedTo: null,
      isCompo: null,
      STUDENT_DATA: {},
      sendLinkDialog: false,
      sendLinkDialogOffline: false,
      sectionID: '',
      classID: '',
      selectedclassID: '',
      selectedclassName: '',
      selectedEnquiryCode: '',
      isDataLoaded: false,
      documentData: [],
      registrationData: [],
      classes: [],
      sections: [],
      YET_TO_CALL: '',
      spancoDefaultStatus: constants.SPANCOSTATUS.DEFAULT,
      spancoDefaultStage: constants.SPANCOSTATUS.DEFAULTSTAGE,
      selectedAssignTo: '',
      selectedEnquiryId: '',
      selectedEnquiry: [],
      currentAssignedUser: '',
      hasClicked: false,
      isSuperAdmin: false,
      headers: [
        { text: 'Interaction Date', sortable: true, value: 'interactionDate' },
        { text: 'Previous Status', sortable: true, value: 'previousStatus' },
        { text: 'Status changed', sortable: true, value: 'statusChangedTo' },
        { text: 'Followup By', sortable: true, value: 'followUpBy' },
        { text: 'Response', sortable: true, value: 'response' },
        { text: 'Remarks', sortable: true, value: 'remarks' },
        { text: 'Action Stage Questions', value: 'actionStageQuestions' },
        {
          text: 'Next Followup Date & Time',
          sortable: true,
          value: 'nextFollowUp'
        }
      ],
      subResponceHeaders: [
        { text: 'name', sortable: true, value: 'name' },
        { text: 'Value', sortable: true, value: 'value' }
      ],
      assignToHeader: [
        { text: 'Previous assignee', value: 'previousAssignee' },
        { text: 'Current assignee', value: 'CurrentAssignee' },
        { text: 'Spanco Status', value: 'spancoName' },
        { text: 'Franchisee', value: 'franchisee.companyName' },
        { text: 'Assigned Date', value: 'date' }
      ],
      callLogsheaders: [
        {
          text: 'First call answer at',
          sortable: true,
          value: 'firstCallAnswerAt'
        },
        {
          text: 'Second call answer at',
          sortable: true,
          value: 'secondCallAnswerAt'
        },
        {
          text: 'Call disconnect at',
          sortable: true,
          value: 'callDisconnectAt'
        },
        { text: 'First call status', sortable: true, value: 'firstCallStatus' },
        {
          text: 'Second call status',
          sortable: true,
          value: 'secondCallStatus'
        },
        { text: 'Created at', sortable: true, value: 'createdAt' }
      ],
      currentFranchiseeArr: [],
      linkSendConfirmDialog: false,
      admissionLinkSendConfirmDialog: false,
      applicationLinkSendConfirmDialog: false,
      isParent: true,
      franchiseeID: '',
      actionStageQuestions: {},
      schoolName: '',
      fees: '',
      otherSchool: false,
      distanceLocationIssue: false,
      ageEligibility: false,
      tempDropPincode: '',
      tempDropLocality: '',
      tempDropAge: '',
      sortedEnquiryStageData: [],
      addButton: true,
      actionStageQt: null,
      pincodeValue: 6,
      modelTitle: '',
      subResponseQuestion: null,
      date: '',
      studentCategory: '',
      classEndDate: moment().add(60, 'days').format('YYYY-MM-DD'),
      isRazorPayAccount: false,
      showAdmissionFormFeeBtnLInk: true,
      showAssignBtn: false,
      showCenterChangeDialog: false,
      franchiseeList: [],
      selectedFranchiseeID: '',
      setSelectedEnquiryId: null,
      isBSKRoleUser: false,
      addNewFollowupData: '',
      addNewFollowupDetails: '',
      temporarilyConfirmed: constants.ENQUIRYSTAGES.TEMPORARILY_CONFIRMED,
      validClassIDs: [254, 255, 256, 257],
      followupdialstatus: [],
      isFirstCall: true,
      allfollowup: []
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    sendLinkDialog: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    },
    sendLinkDialogOffline: function (val) {
      if (val === false) {
        this.sectionID = ''
      }
    },
    isCompo: function (val) {
      document.querySelector('html').style.overflow = val ? 'hidden' : null
    }
  },
  async created () {
    this.isSuperAdmin = Utils.helper.isSuperAdmin()

    if (this.user) {
      this.userID = this.user.id
    }
    try {
      await this.getUserRolesFromIndexDB()
      await this.getEnquiryStages()
      await this.getFollowupDetails()
      await this.getCallLogDetails()
      this.applicationFeeLinkObj =
        constants.ENQUIRYSTAGES.APPLICATION_FEE_LINK_SENT
      this.dropOffObj = constants.ENQUIRYSTAGES.DROP_OFF
      this.admissionFormCompletedObj =
        constants.ENQUIRYSTAGES.ADMISSION_FORM_COMPLETED
      this.admissionConfirmedObj = constants.ENQUIRYSTAGES.ADMISSION_CONFIRMED
      this.spancoDefaultStatus = constants.SPANCOSTATUS.DEFAULT
      this.onlineCounsellingDONE =
        constants.ENQUIRYSTAGES.ONLINE_COUNSELLING_DONE
      this.YET_TO_CALL = constants.ENQUIRYSTAGES.YET_TO_CALL
      this.CLOSE = constants.ENQUIRYSTAGES.CLOSE
      this.offlineCounsellingDONE =
        constants.ENQUIRYSTAGES.OFFLINE_COUNSELLING_DONE
      await this.checkFranchiseeRazorpayAccount()
    } catch (e) {
      const errorMessage =
        (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }
  },
  methods: {
    isDisabled (item) {
      if (this.isFirstCall) {
        this.allfollowup = this.followupData.flat()
        this.isFirstCall = false
      }
      if (this.allfollowup.length === 0) {
        return item.name === 'Dialled 2' || item.name === 'Dialled 3'
      }
      let flagforCounselling = false
      for (const followitem of this.allfollowup) {
        if (followitem.currentStage.name !== 'Counselling Done -Called But No Response' && followitem.currentStage.name === 'Counselling Done') {
          flagforCounselling = true
        }
      }
      for (const followitem of this.allfollowup) {
        if ((this.enquiryStage === followitem.currentStage.id && followitem.currentStage.name === 'Counselling Done -Called But No Response') || (followitem.previousStage.name === 'Counselling Done -Called But No Response' && followitem.currentStage.name === 'Dead') || (flagforCounselling === true)) {
          if (followitem.enquirySubRemark === null) {
            return item.name === 'Dialled 2' || item.name === 'Dialled 3'
          } else if (followitem.enquirySubRemark.name === 'Dialled 1') {
            return item.name === 'Dialled 1' || item.name === 'Dialled 3'
          } else if (followitem.enquirySubRemark.name === 'Dialled 2') {
            return item.name === 'Dialled 1' || item.name === 'Dialled 2'
          } else if (followitem.enquirySubRemark.name === 'Dialled 3') {
            return true
          }
        } else
        if ((this.enquiryStage === followitem.currentStage.id && followitem.currentStage.name === 'Lead Dialled (Not reachable)') || (this.enquiryStage === followitem.previousStage.id && followitem.previousStage.name === 'Lead Dialled (Not reachable)' && followitem.currentStage.name === 'Junk') || (followitem.previousStage.name === 'Junk' && followitem.currentStage.name === 'Junk')) {
          if (!followitem.enquirySubRemark.name) {
            return item.name === 'Dialled 2' || item.name === 'Dialled 3'
          } else if (followitem.enquirySubRemark.name === 'Dialled 1') {
            return item.name === 'Dialled 1' || item.name === 'Dialled 3'
          } else if (followitem.enquirySubRemark.name === 'Dialled 2') {
            return item.name === 'Dialled 1' || item.name === 'Dialled 2'
          } else if (followitem.enquirySubRemark.name === 'Dialled 3') {
            return true
          }
        } else if ((this.enquiryStage === followitem.currentStage.id && followitem.currentStage.name === 'Lead Dialed (Ringing)') || (this.enquiryStage === followitem.previousStage.id && followitem.previousStage.name === 'Lead Dialed (Ringing)' && followitem.currentStage.name === 'Junk') || (followitem.previousStage.name === 'Junk' && followitem.currentStage.name === 'Junk')) {
          if (!followitem.enquirySubRemark.name) {
            return item.name === 'Dialled 2' || item.name === 'Dialled 3'
          } else if (followitem.enquirySubRemark.name === 'Dialled 1') {
            return item.name === 'Dialled 1' || item.name === 'Dialled 3'
          } else if (followitem.enquirySubRemark.name === 'Dialled 2') {
            return item.name === 'Dialled 1' || item.name === 'Dialled 2'
          } else if (followitem.enquirySubRemark.name === 'Dialled 3') {
            return true
          }
        }
      }
      for (const followitem of this.allfollowup) {
        if (this.enquiryStage !== followitem.currentStage.id && followitem.currentStage.name !== 'Counselling Done -Called But No Response') {
          return item.name === 'Dialled 2' || item.name === 'Dialled 3'
        } else if (this.enquiryStage !== followitem.currentStage.id && followitem.currentStage.name !== 'Lead Dialled (Not reachable)') {
          return item.name === 'Dialled 2' || item.name === 'Dialled 3'
        } else if (this.enquiryStage !== followitem.currentStage.id && followitem.currentStage.name !== 'Lead Dialed (Ringing)') {
          return item.name === 'Dialled 2' || item.name === 'Dialled 3'
        }
      }
    },
    getUserRolesFromIndexDB: function () {
      this.isBSKRoleUser = false
      if (stores.user.roles) {
        let obj = stores.user.roles
        obj.forEach(item => {
          if (item.role === constants.BSK_ROLE_NAME) {
            this.isBSKRoleUser = true
          }
        })
      }
    },
    setComponentFlag: function (isCompoFlag) {
      this.isCompo = isCompoFlag
    },
    editRoute: async function () {
      if (this.enquiryDetails.currentStatus === 'Tuition Fee Paid') {
        return this.$dialog.error({
          text: `Fee Plan Assigned, Can Not Edit!`,
          title: 'Error'
        })
      }
      if (
        !this.isAdmin &&
        this.enquiryDetails.currentStatus === 'Admission Form Completed'
      ) {
        return this.$dialog.error({
          text: `The Application fee payment is done. Field not editable.`,
          title: 'Error'
        })
      } else {
        let route = null
        if (this.enquiryDetails.isServiceType) {
          route = this.$router.resolve({
            name: 'editServiceEnquiry',
            params: { enquiryCodeProp: this.enquiryDetails.enquiryCode }
          })
          window.open(route.href, '_blank')
        } else {
          this.$router.push({
            name: 'EditEnquiries',
            params: {
              endpointID: this.enquiryDetails.id,
              enquiryCode: this.enquiryDetails.enquiryCode,
              radio: 'all',
              spancostg: this.enquiryDetails.currentStatus,
              spancostus: this.enquiryDetails.spancoStatus
            }
          })
        }
      }
    },
    refreshList () {
      this.refreshFlag = 1
    },
    assignEnquiryID: function (enquiryIDs) {
      this.isCompo = ''
      this.$nextTick(() => {
        this.isCompo = AssignFeePlan
      })

      this.enquiryIDD = enquiryIDs.id
      this.STUDENT_DATA = enquiryIDs
    },
    toggleSectionModal: async function (enquiryID, classID, enquiryCode) {
      this.sendLinkDialog = true
      const result = await http.get(
        `${constants.API_URL}/api/students/section/${classID}`
      )
      this.sections = result.data
      let sectionArr = this.sections
      this.selectedclassName = sectionArr.name
      if (!_.isEmpty(sectionArr)) {
        this.sections = sectionArr.studentSections
      }
      this.selectedclassID = classID
      this.selectedEnquiryCode = enquiryCode
      this.inProgress = false
    },
    toggleSectionModalOffline: async function (
      enquiryID,
      classID,
      enquiryCode
    ) {
      this.sendLinkDialogOffline = true
      const result = await http.get(
        `${constants.API_URL}/api/students/section/${classID}`
      )
      this.sections = result.data
      let sectionArr = this.sections
      this.selectedclassName = sectionArr.name
      if (!_.isEmpty(sectionArr)) {
        this.sections = sectionArr.studentSections
      }
      this.selectedclassID = classID
      this.selectedEnquiryCode = enquiryCode
      this.inProgress = false
    },
    assignToMe: async function () {
      this.$dialog.info({
        title: 'Assign to Me',
        text: 'Do you want to <b>Assign</b> this task to yourself?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                await http.post(
                  `${constants.API_URL}/api/enquiry/update-assign-to/`,
                  {
                    enquiryID: this.selectedEnquiryId,
                    assignedToID: this.selectedAssignTo
                  }
                )
                this.modalOk = false
                this.okMsg('Enquiry assigned Successfully!')
              } catch (e) {
                const errorMessage =
                  (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                await this.getFollowupDetails()
              }
            }
          }
        }
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    getFollowupDetails: async function () {
      try {
        this.setSelectedEnquiryId = null
        this.showCenterChangeDialog = false
        this.showAdmissionFormFeeBtnLInk = true
        this.showAssignBtn = false
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/followup/details/${this.enquiryCode}`
        )
        this.addNewFollowupDetails = data
        console.log('here is our add new follow up details admission id::::', this.addNewFollowupDetails.admissionID)

        if (data.enquiryData.isServiceType) {
          if (data.enquiryData.enquiryStage.name === constants.ENQUIRYSTAGES.INTELLISKILLS_BSK_FEE_PLAN_ASSIGN) {
            this.showAssignBtn = true
          } else {
            this.showAssignBtn = false
          }
          this.showAdmissionFormFeeBtnLInk = false
        }
        this.disableAppFeeLink = false
        this.enquiryDetails = data.enquiryData
        this.isAdmissionConfirmed = data.isAdmissionConfirmed
        // Beyond Skool Changes
        this.setSelectedEnquiryId = this.enquiryDetails.id
        if (this.enquiryDetails.isServiceType &&
          constants.BSK_FRANCHISEE.name === this.enquiryDetails.franchisee.companyName &&
          constants.BSK_LEVEL_2_CHECK.status === this.enquiryDetails.spancoStatus &&
          constants.BSK_LEVEL_2_CHECK.stageName === this.enquiryDetails.enquiryStage.name
        ) {
          await this.getFranchisee()
          this.showCenterChangeDialog = true
        } else {
          this.showCenterChangeDialog = false
        }

        this.isAdmin = data.adminAccess
        let enquiryObj = this.enquiryDetails
        this.enquiryAssignedTo = data.enquiryData.user
        this.studentCategory = this.enquiryDetails.studentClass ? this.enquiryDetails.studentClass.category : ''
        if (this.studentCategory === constants.classCategory.PARENT_TODDLER) {
          this.disableAppFeeLink = true
        }
        this.$store.commit('updateEnquiryCode', this.enquiryDetails.enquiryCode)
        let enquiryType = ''
        if (this.enquiryDetails.isInterestedForEnquiry === true) {
          if (!_.isEmpty(this.enquiryDetails.enrollmentCode)) {
            enquiryType = 'Admission Taken'
            this.showNIEnqButton = 0
          } else if (!_.isEmpty(this.enquiryDetails.applicationCode)) {
            if (this.enquiryDetails.type === 'REGISTRATION_FORM') {
              enquiryType = 'Registration'
            } else {
              enquiryType = 'Application Taken'
            }
            this.showNIEnqButton = 0
          } else if (!_.isEmpty(this.enquiryDetails.enquiryCodeMCB)) {
            enquiryType = 'MCB Enquiry'
            this.showNIEnqButton = 1
          } else {
            enquiryType = 'Enquiry'
            this.showNIEnqButton = 1
          }
        } else {
          enquiryType = 'Not Interested Enquiry'
          this.showNIEnqButton = 0
        }

        this.enquiryDetails.type = enquiryType
        this.followupData = data.enquiryData.enquiryFollowups

        for (const item of this.followupData) {
          this.followupdialstatus.push(item.enquirySubRemark)
        }
        this.followupdialstatus = this.followupdialstatus.filter((item, index, self) => {
          if (item === null) return false
          return index === self.findIndex((obj) => obj && obj.name === item.name)
        })

        this.enquiryDetails.dateOfEnquiry = moment(
          this.enquiryDetails.dateOfEnquiry
        ).format('D MMM YYYY HH:mm')
        if (!_.isEmpty(this.enquiryDetails.enquiryStageID)) {
          this.enquiryDetails.currentStatus =
            this.enquiryDetails.enquiryStage.name
        } else {
          this.enquiryDetails.currentStatus =
            constants.ENQUIRYSTAGES.YET_TO_CALL
        }
        if (!_.isEmpty(enquiryObj.studentClass)) {
          const classCategory = enquiryObj.studentClass.category
            ? ' (  ' + enquiryObj.studentClass.category + ' )'
            : ''
          this.enquiryDetails.studentClassName =
            enquiryObj.studentClass.name + ' ' + classCategory
        }
        if (!enquiryObj.enquiryStage) {
          enquiryObj.enquiryStage = {
            level: 0,
            statusName: constants.SPANCOSTATUS.DEFAULT,
            name: constants.ENQUIRYSTAGES.YET_TO_CALL
          }
        }

        if (this.followupData) {
          this.followupData.filter((item) => {
            if (!_.isEmpty(item.interactionDate)) {
              item.interactionDate = moment(item.interactionDate).format(
                'MMM DD YYYY, HH:mm'
              )
            }
            if (!_.isEmpty(item.nextFollowUp)) {
              item.nextFollowUp = moment(item.nextFollowUp).format(
                'MMM DD YYYY, HH:mm'
              )
            }
            if (item.actionStageQuestions) {
              item.actionStageQuestions =
                JSON.parse(item.actionStageQuestions) || []
            } else {
              item.actionStageQuestions = []
            }
          })

          let followuprow = this.followupData
          followuprow = followuprow[0]
          if (!_.isEmpty(followuprow.interactionDate)) {
            this.enquiryDetails.interactionDate = moment(
              followuprow.interactionDate
            ).format('DD MMM YYYY HH:mm')
          }
          if (!_.isEmpty(followuprow.nextFollowUp)) {
            this.enquiryDetails.followupDate = moment(
              followuprow.nextFollowUp
            ).format('DD MMM YYYY HH:mm')
          }
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getCallLogDetails: async function () {
      try {
        this.isLoading = true
        const { data } = await http.post(
          `${constants.API_URL}/api/calllog-list`,
          {
            enquiryCode: this.enquiryCode
          }
        )
        this.callLogsData = data
        this.callLogsData.filter((item, index) => {
          item.firstCallAnswerAt = item.firstCallAnswerAt
            ? moment(item.firstCallAnswerAt).format('MMMM Do YYYY, HH:mm a')
            : '-'
          item.secondCallAnswerAt = item.secondCallAnswerAt
            ? moment(item.secondCallAnswerAt).format('MMMM Do YYYY, HH:mm a')
            : '-'
          item.callDisconnectAt = item.callDisconnectAt
            ? moment(item.callDisconnectAt).format('MMMM Do YYYY, HH:mm a')
            : '-'
          item.createdAt = item.createdAt
            ? moment(item.createdAt).format('MMMM Do YYYY, HH:mm a')
            : '-'
        })
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getEnquiryStages: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/enquiry-stages`,
          {
            params: {
              enquiryCode: this.enquiryCode
            }
          }
        )
        this.enquiryStageData = data
        this.enquiryResponse = ''

        this.sortedEnquiryStageData = _.uniqBy(this.enquiryStageData, 'name')

        if (this.enquiryStage) {
          _.filter(this.enquiryStageData, (item) => {
            if (item.id === this.enquiryStage) {
              this.enquirySubRemarksData = item.enquirySubRemarks
                ? item.enquirySubRemarks
                : []
            }
          })
          return this.enquirySubRemarksData
        } else {
          this.enquiryResponse = ''
          this.enquirySubRemarksData = []
        }
        if (!_.isEmpty(this.enquirySubRemarksData)) {
          this.isResponseRequired = true
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry stage data : ', errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    onSubmit: async function (event) {
      try {
        // this.loadingComponent = this.$buefy.loading.open()
        let enquiryActionQuestions = this.enquirySubRemarksData.find(
          (obj) => obj.id === this.enquiryResponse
        )
        this.subResponseQuestion = []
        if (
          enquiryActionQuestions &&
          enquiryActionQuestions.actionStageQuestions &&
          enquiryActionQuestions.actionStageQuestions.length
        ) {
          let subResponseQuestionArray =
            enquiryActionQuestions.actionStageQuestions
          if (subResponseQuestionArray.length) {
            for (let question of subResponseQuestionArray) {
              if (question.value === '' || _.isEmpty(question.value)) {
                this.modelTitle = enquiryActionQuestions.name
                this.subResponseQuestion.push(question)
              }
            }
          }
          if (this.subResponseQuestion.length) {
            this.dialogModel = true
            return
          }
        }
        this.isLoading = true
        this.lock = true
        let followupDateTime = moment(this.followupDateTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        let classStartDate = moment(this.classStartDate).format(
          'YYYY-MM-DD'
        )
        let classEndDate = moment(this.classEndDate).format(
          'YYYY-MM-DD'
        )

        const formData = {
          enquiryCode: this.enquiryCode,
          nextFollowup: followupDateTime,
          actionRemarks: this.actionRemarks,
          enquiryResponse: this.enquiryResponse,
          currentStatus: this.enquiryStage,
          actionStageQuestions: JSON.stringify(this.actionStageQuestions)

          //   franchiseeID: this.enquiryDetails.franchiseeID
        }
        if (this.enquiryStageData[0].name === 'Admission Confirmed' && this.studentCategory === 'Parent Toddler') {
          formData.classStartDate = classStartDate
          formData.classEndDate = classEndDate
        }

        await http.post(`${constants.API_URL}/api/addNewFollowup`, formData)

        this.isLoading = false

        await this.getFollowupDetails()
        await this.refreshList()
        await this.getEnquiryStages()
        this.modelReset()
        this.enquiryStage =
          this.followupDate =
          this.followupTime =
          this.enquiryResponse =
          this.actionRemarks =
          ''
        this.isLoading = false
        console.log('here is our add this.addNewFollowupData.msg:::::', this.addNewFollowupData.msg)
        if (this.addNewFollowupData.msg === 'Error in Kit Order!') {
          return this.$dialog.error({
            text: this.addNewFollowupData.msg,
            title: 'Error'
          })
        } else {
          return this.$dialog.info({
            text: 'Followup added successfully!',
            title: 'Info'
          })
        }
      } catch (e) {
        this.isLoading = false

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    confirmSendAdmissionLink: async function () {
      this.linkSendConfirmDialog = true
    },

    confirmSendApplicationLink: async function () {
      this.applicationLinkSendConfirmDialog = true
    },
    sendApplicationLink: async function (
      _enquiryCode,
      isOffline = false,
      isPayment = false
    ) {
      try {
        this.isLoading = true
        this.lock = true

        const formData = {
          enquiryCode: this.enquiryCode,
          mode: isOffline ? 'OFFLINE' : 'ONLINE',
          type: isPayment
            ? constants.UserReferenceType.applicationForm
            : constants.UserReferenceType.applicationFormFill
        }
        let successMsg = 'Email is sent to for further process !'
        if (formData.type === constants.UserReferenceType.applicationForm) {
          successMsg =
            'Email is sent to parent for filling the Application fees !'
        } else if (
          formData.type === constants.UserReferenceType.applicationFormFill
        ) {
          successMsg =
            'Email is sent to parent for filling admission form details !'
        }

        if (isOffline) {
          formData.type = constants.UserReferenceType.applicationFormOffline
        }
        if (isOffline && !isPayment) {
          formData.type = constants.UserReferenceType.applicationFormFillOffline
        }
        formData.isParent = this.isParent
        /** * generate Application link */
        const response = await http.post(
          `${constants.API_URL}/api/generateApplicationFormLink`,
          formData
        )
        this.isLoading = false
        if (isOffline) {
          let route = this.$router.resolve({
            name: 'applicationFormOffline',
            params: { refID: response.data }
          })
          // this.$router.push({ name: 'applicationFormOffline', params: { refID: response.data } })
          if (isPayment) {
            route = this.$router.resolve({
              name: 'OfflinePayments',
              params: { referenceID: response.data }
            })
            // let route = this.$router.resolve('/link/to/page'); // This also works.
          }
          window.open(route.href, '_blank')
        } else {
          await this.getFollowupDetails()
          await this.refreshList()
          await this.getEnquiryStages()
          return this.$dialog.info({
            text: successMsg,
            title: 'Info'
          })
        }
        this.linkSendConfirmDialog = false
        this.applicationLinkSendConfirmDialog = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
        this.linkSendConfirmDialog = false
        this.applicationLinkSendConfirmDialog = false
      }
    },
    sendRegistrationFormLinkToParent: async function (enqID) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.lock = true

        const formData = {
          enquiryID: enqID
        }

        /** * generate Application link */
        await http.post(
          `${constants.API_URL}/api/generateRegistrationFormLink`,
          formData
        )

        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Email is sent to parent to fill further details !',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },

    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    connectCall: async function (parentType) {
      try {
        this.isLoading = true
        const formData = {
          enquiryID: this.enquiryDetails.id,
          parentType: parentType,
          userID: stores.user.userInfo ? stores.user.userInfo.id : ''
        }
        const resp = await http.post(
          `${constants.API_URL}/api/make-call`,
          formData
        )
        this.isLoading = false

        if (resp) {
          return this.$dialog.info({
            text: 'Call connected !',
            title: 'Info'
          })
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    confirmSendTutionFee: async function () {
      this.admissionLinkSendConfirmDialog = true
    },
    sendAdmissionLink: async function (isOffline = false) {
      try {
        if (!this.sectionID) {
          return this.$dialog.error({
            text: `Select Section`,
            title: 'Error'
          })
        }
        this.loadingComponent = this.$buefy.loading.open()
        this.lock = true

        const formData = {
          enquiryCode: this.selectedEnquiryCode,
          sectionID: this.sectionID,
          mode: isOffline ? 'OFFLINE' : 'ONLINE',
          isParent: this.isParent
        }

        /** * generate Admission link */
        const response = await http.post(
          `${constants.API_URL}/api/generateAdmissionFormLink`,
          formData
        )
        this.loadingComponent.close()
        if (isOffline) {
          this.sendLinkDialogOffline = false

          // this.$router.push({ name: 'admissionFormOffline', params: { refID: response.data } })

          let route = this.$router.resolve({
            name: 'OfflinePayments',
            params: { referenceID: response.data }
          })
          // let route = this.$router.resolve('/link/to/page'); // This also works.
          window.open(route.href, '_blank')
        } else {
          this.sendLinkDialog = false
          this.sendLinkDialogOffline = false
        }
        this.sendLinkDialog = false
        this.sendLinkDialogOffline = false
        if (!isOffline) {
          return this.$dialog.info({
            text: `Email is sent to parent for Tuition fee payment !`,
            title: 'Success'
          })
        }
        this.admissionLinkSendConfirmDialog = false
      } catch (e) {
        this.loadingComponent.close()
        this.sendLinkDialog = false
        this.sendLinkDialogOffline = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: `${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
        this.admissionLinkSendConfirmDialog = false
      }
    },
    passed: function () {
      let enquiryActionQuestions = this.enquirySubRemarksData.find(
        (obj) => obj.id === this.enquiryResponse
      )
      this.subResponseQuestion = []
      this.actionStageQuestions = null
      if (
        enquiryActionQuestions &&
        enquiryActionQuestions.actionStageQuestions &&
        enquiryActionQuestions.actionStageQuestions.length
      ) {
        let subResponseQuestionArray =
          enquiryActionQuestions.actionStageQuestions
        if (subResponseQuestionArray.length) {
          for (let question of subResponseQuestionArray) {
            if (question.value === '' || _.isEmpty(question.value)) {
              this.modelTitle = enquiryActionQuestions.name
              this.subResponseQuestion.push(question)
            }
          }
        }
        if (this.subResponseQuestion.length) {
          this.dialogModel = true
        }
      }
    },
    addActionStageData: function () {
      try {
        let allQuestionAnswered = true
        let allQuestionanswer = []
        if (this.subResponseQuestion.length) {
          for (let question of this.subResponseQuestion) {
            if (question.value === '' || _.isEmpty(question.value)) {
              allQuestionAnswered = false
            }
            allQuestionanswer.push({
              name: question.name,
              value: question.value
            })
          }
          if (!allQuestionAnswered) {
            return
          }
          this.actionStageQuestions = allQuestionanswer
          this.dialogModel = false
        }
        this.addButton = true
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('error while adding the data : ', errorMessage)
      }
    },
    closeModal () {
      this.dialogModel = false
    },
    modelReset () {
      this.actionStageQuestions = null
      this.subResponseQuestion = []
      this.modelTitle = null
    },
    onlyNumber ($event) {
      // console.log($event.keyCode); //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault()
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (!this.franchiseeID) {
          Utils.helper.openDrawer(this)
        } else {
          Utils.helper.openDrawer(this, false)
        }
        this.inProgress = false
      }
    },
    changeClassEndDate: async function () {
      if (this.classStartDate) {
        this.classEndDate = moment(this.classStartDate).add(60, 'days').format('YYYY-MM-DD')
      } else {
        this.classEndDate = null
      }
    },
    checkFranchiseeRazorpayAccount: async function () {
      try {
        const Data = await http.get(
          `${constants.API_URL}/api/franchisee/${this.enquiryDetails.franchisee.id}`
        )
        let getRazorPayAccount = Data.data
        if (!getRazorPayAccount.razorPayAccountID) {
          this.isRazorPayAccount = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee/get/all-active`)
        this.franchiseeList = res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    changeCenter: async function () {
      try {
        let payload = {}
        payload.franchiseeID = this.selectedFranchiseeID
        let res = await http.post(`${constants.API_URL}/api/service/update-franchisee/${this.setSelectedEnquiryId}`, payload)
        if (res.status === 200) {
          await this.setCenterChangeStatus()
          this.showCenterChangeDialog = false
        } else {
          this.errMsg('Failed to change center.')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    setCenterChangeStatus: async function () {
      try {
        let followupDateTime = moment(this.followupDateTime).format(
          'YYYY-MM-DD HH:mm:ss'
        )
        this.sortedEnquiryStageData.forEach(item => {
          if (item.name === constants.BSK_CENTER_CHANGES_TXT) {
            this.enquiryStage = item.id
          }
        })
        this.actionRemarks = ''
        this.enquiryResponse = ''
        this.actionStageQuestions = {}
        const formData = {
          enquiryCode: this.enquiryCode,
          nextFollowup: followupDateTime,
          actionRemarks: this.actionRemarks,
          enquiryResponse: this.enquiryResponse,
          currentStatus: this.enquiryStage,
          actionStageQuestions: JSON.stringify(this.actionStageQuestions)
        }
        const res = await http.post(`${constants.API_URL}/api/addNewFollowup`, formData)
        if (res.status === 200) {
          await this.getFollowupDetails()
          this.refreshList()
          await this.getEnquiryStages()
          this.modelReset()
          this.enquiryStage = ''
          this.followupDate = ''
          this.followupTime = ''
          this.enquiryResponse = ''
          this.actionRemarks = ''
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    reAssignOrder: async function () {
      try {
        console.log('Re-Assign Order Clicked && this.addNewFollowupData.admissionID', this.addNewFollowupDetails.admissionID)

        if (!this.addNewFollowupDetails || !this.addNewFollowupDetails.admissionID) {
          console.error('Missing admissionID in addNewFollowupData')
          return this.$dialog.error({
            title: 'Error',
            text: 'Admission ID is missing. Unable to reassign order.'
          })
        }

        const response = await http.post(`${constants.API_URL}/api/assign-orders`, {
          admissionID: this.addNewFollowupDetails.admissionID
        })

        console.log('Re-Assign Order Response:', response.data)

        if (response.data && response.data.status === 200) {
          this.$dialog.info({
            title: 'Success',
            text: response.data.message
          }).then(() => {
            window.location.reload()
          })
        } else {
          this.$dialog.error({
            title: 'Error',
            text: response.data.message || 'Failed to reassign order.'
          })
        }
      } catch (error) {
        console.error('Error during Re-Assign Order:', error)

        this.$dialog.error({
          title: 'Error',
          text: error.response?.data?.message || error.message || 'An unexpected error occurred.'
        })
      }
    }
  }
}
</script>
<style scoped>
.title,
.subtitle {
  word-break: unset;
}
.hyperlink{
text-decoration: underline
}
.spanTitle {
  font-size: initial;
}
</style>
